<template>
  <div class="forms__field-wrapper" :class="extraClasses">
    <fieldset class="dropdown-wrapper" :class="{ 'error-select' : showFormError }">
      <p class="field-description" v-if="fieldData.description" v-html="fieldData.description"/>
      <div class="input-wrapper" :class="{ 'error': showFormError,  'required': required, 'selected': selected }">
        <label class="floating-label" :for="id">{{ label }}</label>
        <select :id="id" @input="onInput">
          <option v-for="(option, index) in optionList"
            :value="option.value"
            :name="fieldData.name"
            :key="`${fieldData.name}-${index}`"
            :selected="value == option.value"
            :required="required"
            @input="onInput"
          >
            {{ option.label }}
          </option>
        </select>
      </div>
      <p class="forms__error-message" v-t="'errors.required_field'" v-if="showFormError" role="alert"/>
    </fieldset>
  </div>
</template>

<script>
import AbstractField from "@/util/AbstractField";
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
  name: "dropdown",
  mixins: [AbstractField],
  watch: {
    "$store.state.user.userLoggedIn": function () {
      if (this.fieldData.crm_id == 'Salutation') {
        this.value = this.user.userDetails.salutation;
      }
    },
  },
  created() {
    if (this.fieldData.crm_id == 'Salutation' && _.get(this.user.userDetails, salutation, false)) {
      this.value = this.user.userDetails.salutation;
    }
  },
  methods: {
    onInput(e) {
      this.value = e.target.value;
    },
  },
  computed: {
    optionList() {
      let nullValue = { value: null, label: '' };
      return [nullValue, ...this.fieldData.options];
    },
    selected() {
      if(this.value == undefined || this.value == "") {
        return false
      }

      return true
    },
    ...mapState(['user'])
  },
};
</script>